import { render, staticRenderFns } from "./ModalAddNewParticipant.vue?vue&type=template&id=24adbca5&scoped=true&"
import script from "./ModalAddNewParticipant.vue?vue&type=script&lang=js&"
export * from "./ModalAddNewParticipant.vue?vue&type=script&lang=js&"
import style0 from "./ModalAddNewParticipant.vue?vue&type=style&index=0&id=24adbca5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24adbca5",
  null
  
)

export default component.exports